import { useApp } from '../../../context/AppContext';

//import resources
import { IoLocationOutline } from "react-icons/io5";

export default function Address({className}) {

    const { contact } = useApp();

    return(
        <div className={className}><IoLocationOutline className="text-[26px] me-2" /> { contact?.data?.translations[0]?.address }  </div>
    );
}